import { ThemeEvents } from '@theme/events';

const TOAST_DURATION = 10000;
const ADDED_STATE_DURATION = 800;

/** @type {number | undefined} */
let toastTimeout;

/** @param {HTMLElement} section */
function showToast(section) {
  const toast = section.querySelector('.macro-showcase__toast');
  if (!(toast instanceof HTMLElement)) return;

  toast.hidden = false;
  toast.classList.add('is-visible');

  if (toastTimeout) {
    window.clearTimeout(toastTimeout);
  }

  toastTimeout = window.setTimeout(() => {
    toast.classList.remove('is-visible');
    toast.hidden = true;
  }, TOAST_DURATION);
}

/** @param {Event} event */
function handleCartUpdate(event) {
  const detail = /** @type {CustomEvent} */ (event).detail?.data;
  if (!detail || detail.didError || detail.source !== 'product-form-component') return;

  const productForm = event.target;
  if (!(productForm instanceof HTMLElement) || productForm.tagName !== 'PRODUCT-FORM-COMPONENT') return;

  const section = productForm.closest('.macro-showcase');
  if (!(section instanceof HTMLElement)) return;

  showToast(section);
}

/** @param {Event} event */
function handleFooterAddClick(event) {
  const button = event.target instanceof Element ? event.target.closest('.macro-nutrition-dialog__footer-add') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled || !button.form) return;
  if (!button.closest('.macro-showcase')) return;

  button.dataset.added = 'true';
  window.setTimeout(() => {
    button.removeAttribute('data-added');
  }, ADDED_STATE_DURATION);
}

document.addEventListener(ThemeEvents.cartUpdate, handleCartUpdate);
document.addEventListener('click', handleFooterAddClick, true);
